import React from 'react'

import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Section6 from './Section6';
import Section1 from './Section1';
import Section7 from './Section7';
import Footer from './Footer';
import TailwindSection from './TailwindSection';
import Testimonials from './Testimonials';
import Shots from './Shots';
import Steps from './Steps';
import Section2M from './Section2M';
import Fees from './Fees';
import Section2MT from './Section2MT';
import { Section2F } from './Section2F';



export default function Home() {
  return (
    <>
    <Section1/>
    {/* <Section2M /> */}
    <Section2F/>
    <Section3 />
    <Steps/>
    <Section4 />
    <TailwindSection/>
    <Section5 />
    <Testimonials/>
    {/* <Fees/> */}
    <Section6 />
    <Section7 />
    <Footer />
  </>
  )
}
